import React, { useState } from "react";
import { Link } from "react-router-dom";
import NoDataText from "../NoDataText";
import Pagination from "../Pagination/Pagination";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import SearchBarResults from "../Search/SearchBarResults";

const TopCouponsNew = (props) => {
  const {
    TableData,
    totalPageCount,
    setPageNumber,
    limit,
    handleSearchInput,
    handleKeypress,
    handleSearch,
    searchValue,
    HandleSortCol,
    flag,
  } = props;

  return (
    <>
      <div className="manage-vou-main pt-4 Blist">
        <p className="page-maintitle">Latest Coupons Listed</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              className="search_feild"
              value={searchValue}
              onChange={(e) => handleSearchInput(e)}
              onKeyPress={handleKeypress}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
        </div>
      </div>
      <SearchBarResults SearchValue={searchValue} />
      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table vou-list-Table Top-coup-table">
          <thead>
            <tr>
              <th
                style={{ textAlign: "left", width: "400px" }}
                onClick={() => HandleSortCol("coupon_name")}
              >
                <Button className="btn btn-primary sortIcon">
                  Coupons Name
                  {flag.coupon_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.coupon_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th
                onClick={() => HandleSortCol("bi_name")}
                style={{ textAlign: "left", width: "300px" }}
              >
                <Button className="btn btn-primary sortIcon ">
                  Business Name
                  {flag.business_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.business_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th
                onClick={() => HandleSortCol("download_count")}
                // style={{ textAlign: "left",width: "300px" }}
              >
                <Button
                  className="btn btn-primary sortIcon"
                  style={{ margin: "auto" }}
                >
                  Coupons Downloaded
                  {flag.download_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.download_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th
                onClick={() => HandleSortCol("redeemed_count")}
                // style={{ textAlign: "left"}}
              >
                <Button
                  className="btn btn-primary sortIcon"
                  style={{ margin: "auto" }}
                >
                  Coupons Redeemed
                  {flag.redeemed_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.redeemed_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  className="btn btn-primary sortIcon"
                  style={{ margin: "auto" }}
                >
                  Coupons Active
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {TableData.length != 0 ? (
              <>
                {TableData.map((i, k) => {
                  return (
                    <tr>
                      <td
                        style={{ textAlign: "left" }}
                        title={i["coupon_name"]}
                      >
                        <Link
                          className="vouname-blue"
                          to={`/coupons/couponsDetails/${i.city_coupon_id}`}
                        >
                          {i["coupon_name"]}
                        </Link>
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {i["business_name"]}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {i["coupons_downloaded"]}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {i["coupons_redeemed"]}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {i["coupons_active"] != null
                          ? i["coupons_active"]
                          : "-"}
                      </td>
                    </tr>
                  );
                })}{" "}
              </>
            ) : (
              <tr class="toggle-row">
                <td colspan="8">
                  <p class="noData">{NoDataText.ErrText}</p>{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {TableData.length != 0 ? (
        <Pagination
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default TopCouponsNew;
